import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-successive-delivery',
  templateUrl: './successive-delivery.component.html',
  styleUrls: ['../modal.component.scss']
})

export class SuccessiveDeliveryComponent {
  @Input() order: any;
  @Output() readonly responseChanged = new EventEmitter();

  emitFalse(): void {
    this.responseChanged.emit(false);
  }
}